import { IconCategory } from "../model/app/propTypes";

import { Domain } from "./constants";
import globalIconsCh from "./globalIconsCh.json";
import globalIconsIo from "./globalIconsIo.json";

const globalIconsByDomain: Record<Domain, IconCategory[]> = {
  app: globalIconsIo, // app configs must used iconSet property not iconCatgeories directly
  ch: globalIconsCh,
  io: globalIconsIo,
};

export function getGlobalIconsByDomain(domain: Domain) {
  return globalIconsByDomain[domain] || [];
}
